// removed by extract-text-webpack-plugin
module.exports = {"screen":"_362t4J7EgBoP4sP3hXnjwO"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/PageBasic.scss
// module id = 551
// module chunks = 0